import { GeoEventRegion } from 'features/geoEvents/geoEventRegion.types';

export const newRegionIsAdded = (
  prev: GeoEventRegion[],
  next: GeoEventRegion[] | null,
): boolean => {
  const nextRegions = next || [];
  const prevIds = new Set(prev.map((r) => r.id));

  return nextRegions.some((r) => !prevIds.has(r.id));
};

export const regionIsRemoved = (
  prev: GeoEventRegion[],
  next: GeoEventRegion[] | null,
): boolean => {
  const nextRegions = next || [];
  const nextIds = new Set(nextRegions.map((r) => r.id));

  return prev.some((r) => !nextIds.has(r.id));
};

export type GeoEventRegionsChanged = {
  regionsAdded: boolean;
  regionsRemoved: boolean;
};

export const getGeoEventRegionsChanged = (
  baselineRegions: GeoEventRegion[],
  regions: GeoEventRegion[] | null,
): GeoEventRegionsChanged => ({
  regionsAdded: newRegionIsAdded(baselineRegions, regions),
  // A null `regions` means the field is not registered yet, not that every
  // baseline region was removed.
  regionsRemoved: regions ? regionIsRemoved(baselineRegions, regions) : false,
});
